import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';

const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success(t('forgotPassword.resetLinkSent', 'If an account exists, a reset link has been sent.'));
    } catch {
      toast.error(t('forgotPassword.failedToSend', 'Failed to send reset link'));
    } finally { setLoading(false); }
  };

  return (
    <div className="w-full max-w-md mx-auto" dir={isRTL ? 'rtl' : 'ltr'}>
      {!sent ? (
        <form onSubmit={submit} className="space-y-6">
          <h1 className="text-2xl font-bold text-gray-900 text-center">{t('forgotPassword.title', 'Forgot Password')}</h1>
          <Input label={t('forgotPassword.emailLabel', 'Email')} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <Button type="submit" loading={loading} className="w-full">{t('forgotPassword.sendResetLink', 'Send Reset Link')}</Button>
          <div className="text-center text-sm"><Link to="/login" className="text-primary-600">{t('forgotPassword.backToLogin', 'Back to login')}</Link></div>
        </form>
      ) : (
        <div className="space-y-4 text-center">
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 text-emerald-800 p-4">{t('forgotPassword.checkEmail', 'Check your email for the reset link.')}</div>
          <Link to="/login"><Button>{t('forgotPassword.goToLogin', 'Go to Login')}</Button></Link>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;


